import { createMetricsFactory } from 'metrics-js';
export const UIAUMetrics = createMetricsFactory('ui-addon-upgrades', {
  library: 'ui-addon-upgrades'
});
export const trackUpgradePointTooltipFailure = upgradeKey => {
  UIAUMetrics.counter('locked-feature-tooltip-failure', {
    upgradeKey
  }).increment();
};
export const trackUpgradeBannerFailure = upgradeKey => {
  UIAUMetrics.counter('upgrade-banner-failure', {
    upgradeKey
  }).increment();
};